@custom-media --mobile (max-width: 768px);

.feedbackCalculated {
  font-size: 0.9em;
  margin-top: -1.5em;
  display: flex;
  justify-content: flex-end;
}

.responseLink {
  display: block;
  padding: 1.5em 1em;
  position: relative;
  overflow: hidden;
  width: 16em;
  height: 16em;
  background-color: var(--blue);
  color: var(--white);

  p {
    margin-bottom: 0;
  }

  & .surveyType {
    text-transform: uppercase;
    font-size: 0.7em;
    margin-bottom: 0.5em;

    p {
      font-size: 1em;
    }
  }

  & .surveyTitle {
    font-weight: bold;
    font-size: 1.2em;
    max-height: 8em;
    overflow: hidden;

    p {
      font-size: 1em;
    }

    &::before {
      content: '';
      width: 100%;
      height: 100%;
      max-height: 9em;
      margin-top: 1.5em;
      position: absolute;
      left: 0;
      top: 0;
      background: linear-gradient(rgb(16 126 171 / 0%) 3em, var(--blue)); /* transparent --blue */
    }
  }

  & .responseDate {
    text-transform: uppercase;
    font-size: 0.6em;
    position: absolute;
    bottom: 3em;
    right: 1.5em;

    p {
      font-size: 1em;
    }
  }

  &:hover,
  &:focus {
    color: var(--white);
    background-color: var(--blueActive);

    & .surveyTitle::before {
      background: linear-gradient(rgb(14 104 139 / 0%) 3em, var(--blueActive)); /* transparent --blueActive */
    }
  }
}

@media (--mobile) {
  .responseLink {
    width: 100%;
    margin: 0 0 1em;
  }
}
